import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/communication')({
    component: RouteComponent,
    staticData: {
        crumb: {
            label: 'Communications',
        },
    },
})

function RouteComponent() {
    return <Outlet />
}
